var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57573 8.4243C9.81005 8.18998 9.81005 7.81008 9.57574 7.57577L7.02427 5.02428C6.64629 4.64629 6 4.91399 6 5.44854L6 10.5515C6 11.086 6.64628 11.3537 7.02426 10.9757L9.57573 8.4243Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMonth);
export default __webpack_public_path__ + "static/media/arrow-right-month.0dceb05e40a0c575a09f3e5feca3c3f1.svg";
export { ForwardRef as ReactComponent };